import { Alert } from '@components/general/Alertas/Alertas'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import getUnixTimestamp from '@helpers/dates/getUnixTimestamp/getUnixTimestamp'
import { addSolicitud, sendMailNuevaLeccion } from '@helpers/httpRequests/httpRequestsForoEmpresarial/httpRequestsForoEmpresarial'
import { t } from 'i18next'
import React, { useState } from 'react'
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import ReactInputMask from 'react-input-mask'
import Swal from 'sweetalert2'

const NuevaSolicitud = ({idGrupo, asesor}) => {

    const {nombreCompleto, apellidos, correo} = asesor;

    const [fileBase64, setFileBase64] = useState(null);

    	//STATE PARA LOADER
	const [showLoader, setShowLoader] = useState(false);

    const [formValues, setFormValues] = useState({
        titulo: '',
        descripcion: '',
        contenido: '',
        archivoAdjunto: '',
        telefono: '',
    })

    const [validacionForm, setValidacionForm] = useState({
        titulo: false,
        descripcion: false,
        contenido: false,
        telefono: false,
        archivoAdjunto: false,
        archivoAdjuntoInvalido: false
    })



    const handleOnChange = ({target}) => {
        const {name, value} = target;

        setFormValues({
            ...formValues,
            [name]: value
        })

        if(value === ""){
			setValidacionForm({
				...validacionForm,
				[name]: !validacionForm.name
			});
		}else{
			setValidacionForm({
				...validacionForm,
				[name]: false
			});
		}
    }


    const handleOnChangeFile = (event) => {
        const {name, value} = event.target;

        const file = event.target.files[0]
        // console.log(file);


        setFormValues({
            ...formValues,
            [name]: file
        })

        setValidacionForm({
            ...validacionForm,
            [name]: false
        });


        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
        setFileBase64(reader.result.split(',')[1]);
        };
    }


    const enviarSolicitud = async(e) => {
        e.preventDefault();
        try {
            setShowLoader(true)
            //SE DIVIDE EN DOS, UNA SOLICITUD ENVIA LOS DATOS A LA BASE DE DATOS Y OTRA ENVIA EL ARCHIVO A ALMACENARSE EN SERVIDOR

            const {titulo, descripcion, contenido, archivoAdjunto, telefono} = formValues;
            

            if (titulo === "") {
                // console.log("TITULO");
                setValidacionForm({
                    ...validacionForm,
                    titulo: true,
                });
            } else if (descripcion === "") {
                // console.log("DESCRIPCION");
                setValidacionForm({
                    ...validacionForm,
                    descripcion: true,
                });
            }else if(contenido === ""){
                // console.log("CONTENIDO");
                setValidacionForm({
                    ...validacionForm,
                    contenido: true,
                });
            }else if(archivoAdjunto === ""){
                // console.log("ARCHIVO ADJUNTO");
                setValidacionForm({
                    ...validacionForm,
                    archivoAdjunto: true,
                })
            }else if(telefono === ""){
                setValidacionForm({
                    ...validacionForm,
                    telefono: true,
                })
            }

                    
                
                setValidacionForm({
                    ...validacionForm,
                    archivoAdjuntoInvalido: false
                })
 
               if(titulo !== "" && descripcion !== "" && contenido !== "" && telefono !== ""){
                console.log("Entra para add solicitud")
                 const datosSolicitud= {
                     titulo,
                     descripcion,
                     contenido,
                     fecha: getUnixTimestamp(),
                     archivoAdjunto: archivoAdjunto.name,
                     tipoArchivoAdjunto: archivoAdjunto.type,
                     idGrupo: idGrupo,
                     base64Archivo: fileBase64,
                     nombreAsesor: nombreCompleto + " " + apellidos,
                     correoAsesor: correo,
                     telefono
                 } 

                 console.log(datosSolicitud);
                     
                 const {message} = await addSolicitud(datosSolicitud);

                 console.log(message);

                const {message: respuestaSolicitud} = await sendMailNuevaLeccion(datosSolicitud);
 
                //  Alert(t('businessForum.lessonRequestedTitle'), "success", t('businessForum.lessonRequestedDescription'))
                 Swal.fire({
                    title: t('businessForum.lessonRequestedTitle'),
                    icon: "success",
                    text:  t('businessForum.lessonRequestedDescription'),
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: t('ok'),
                  });
 
               }
    
     

        } catch (error) {
            console.log(error);
        }
    }


  return (
    <Container>
        <Row>
            <Col className='text-left'>
            
                <Form className='text-start' onSubmit={enviarSolicitud}>

                    <Form.Group className="mb-3">
                        <Form.Label>{t('businessForum.lessonTitle')}</Form.Label>
                        <Form.Control className={validacionForm.titulo ? 'is-invalid' : ''} value={formValues.titulo} onChange={handleOnChange} name='titulo' type='text' placeholder={t('businessForum.lessonTitle')}></Form.Control>

                        <Form.Control.Feedback type="invalid">{t('fieldRequired')}</Form.Control.Feedback>
                    </Form.Group>


                    <Form.Group className="mb-3">
                        <Form.Label>{t('businessForum.lessonDescription')}</Form.Label>
                        <Form.Control className={validacionForm.descripcion ? 'is-invalid' : ''} value={formValues.descripcion} onChange={handleOnChange} name='descripcion' rows={4} as={"textarea"} placeholder={t('businessForum.lessonDescription')}></Form.Control>

                        <Form.Control.Feedback type="invalid">{t('fieldRequired')}</Form.Control.Feedback>
                    </Form.Group>


                    <Form.Group className="mb-3">
                        <Form.Label>{t('businessForum.lessonContent')}</Form.Label>
                        <Form.Control className={validacionForm.contenido ? 'is-invalid' : ''} value={formValues.contenido} onChange={handleOnChange} name='contenido' rows={4} as={"textarea"} placeholder={t('businessForum.lessonContent')}></Form.Control>

                        <Form.Control.Feedback type="invalid">{t('fieldRequired')}</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>
                            <h6>{t('phoneNumber')}</h6>
                        </Form.Label>
                        {/* <Form.Control className='input-form' required onChange={handleOnChange} value={formValues.telefono} name="telefono" type="tel" placeholder="Número de teléfono"></Form.Control> */}

                        <ReactInputMask
                            className={`input-form form-control ${validacionForm.telefono ? 'is-invalid' : ''}`}
                            mask="(999) 999-9999"
                            placeholder='(xxx) xxx xxxx'
                            maskChar=" "
                            required
                            onChange={handleOnChange}
                            value={formValues.telefono}
                            name="telefono"
                            type="tel"
                        />

                        <Form.Control.Feedback type="invalid">
                            <p>{t('fieldRequired')}o</p>
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className='mb-3'>
                        <Form.Label>
                            <h6>{t('businessForum.downloadableContent')}</h6>
                        </Form.Label>
                        <Form.Control className='mb-3' onChange={handleOnChangeFile} type='file' name='archivoAdjunto' ></Form.Control>

                        {validacionForm.archivoAdjunto && (
                            <p className='text-danger mt-3'><FontAwesomeIcon icon={faExclamationCircle}/> {t('fieldRequired')}</p>
                        )}

                        {validacionForm.archivoAdjuntoInvalido && (
                            <p className='text-danger mt-3'><FontAwesomeIcon icon={faExclamationCircle}/>{t('businessForum.fileInvalid')}</p>
                        )}
                        <small className='mt-2'>{t('businessForum.downloadableContentDescription')}</small>
                    </Form.Group>

                    

                    <div className="d-grid gap-2">
					<Button  disabled={showLoader ? true: false} type='submit' block>{t('submitRequest')}{showLoader && (
                        <Spinner animation="border" style={{width: "1rem", height: "1rem", verticalAlign: "middle"}} className={`mx-3${!setShowLoader ? "d-none" : ""}`} />
                    )}</Button>
					</div>

                </Form>
            
            
            </Col>
        </Row>
    </Container>
  )
}

export default NuevaSolicitud